(function () {
  'use strict';
  const initialized = new WeakSet();
  document.addEventListener('click', function (event) {
    const link = event.target.closest('a[href="#bql-quote"]');
    const root = link && link.closest('#b2b-quote-page');
    if (!root) return;
    const form = root.querySelector('#bql-quote');
    if (!form) return;
    let target = form.querySelector('#bql-email, [data-bql-success]');
    const select = link.dataset.bqlProduct
      ? form.querySelector('#bql-product')
      : link.dataset.bqlUsecase ? form.querySelector('#bql-usecase') : null;
    if (select) {
      const value = link.dataset.bqlProduct || link.dataset.bqlUsecase;
      const option = Array.from(select.options).find(item => item.value === value);
      if (option) {
        select.value = option.value;
        select.dispatchEvent(new Event('input', {bubbles: true}));
        select.dispatchEvent(new Event('change', {bubbles: true}));
        const details = select.closest('details');
        if (details) details.open = true;
        target = select;
      }
    }
    event.preventDefault();
    event.stopPropagation();
    if (target) {
      target.scrollIntoView({behavior: 'instant', block: 'center'});
      target.focus({preventScroll: true});
    } else {
      form.scrollIntoView({behavior: 'instant', block: 'start'});
    }
  }, true);
  function initialize() {
  const root = document.getElementById('b2b-quote-page');
  if (!root || initialized.has(root)) return;
  initialized.add(root);
  const form = root.querySelector('#bql-quote');
  const sticky = root.querySelector('[data-bql-sticky]');
  const product = root.querySelector('#bql-product');
  const usecase = root.querySelector('#bql-usecase');
  function updateSticky() {
    if (!form || !sticky) return;
    const bounds = form.getBoundingClientRect();
    const visible = bounds.top < window.innerHeight && bounds.bottom > 0;
    sticky.hidden = visible || !!root.querySelector('[data-bql-success]');
  }
  if (form && sticky) {
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(updateSticky, {threshold: [0, 0.01]});
      observer.observe(form);
    } else {
      window.addEventListener('scroll', updateSticky, {passive: true});
    }
    window.addEventListener('resize', updateSticky, {passive: true});
    updateSticky();
  }
  const campaign = root.querySelector('#bql-campaign');
  if (campaign) {
    const params = new URLSearchParams(window.location.search);
    campaign.value = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].flatMap(key => {
      const value = params.get(key);
      return value && !/[{}]/.test(value) ? [key + ': ' + value.slice(0, 160).replace(/[\r\n]/g, ' ')] : [];
    }).join(' | ');
  }
  if (form) {
    form.addEventListener('submit', function () {
      const body = form.querySelector('#bql-body');
      if (!body) return;
      const quantity = form.querySelector('#bql-quantity');
      const message = form.querySelector('#bql-message');
      const lines = ['Zapytanie firmowe'];
      if (product) lines.push('Produkt: ' + product.value);
      if (quantity) lines.push('Liczba sztuk: ' + quantity.value);
      if (usecase && usecase.value) lines.push('Zastosowanie: ' + usecase.options[usecase.selectedIndex].text);
      if (message && message.value.trim()) lines.push('Szczegóły projektu: ' + message.value.trim());
      lines.push('Logo: do przesłania e-mailem; formularz nie zawiera załącznika.');
      body.value = lines.join('\n');
    });
  }
  const feedback = root.querySelector('[data-bql-success], #bql-errors');
  if (feedback) {
    feedback.scrollIntoView({block: 'center'});
    feedback.focus({preventScroll: true});
  }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, {once: true});
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', initialize);
})();
